import { useState } from 'react';

const defaultFaqs = [
  {
    question: 'What exactly is a "trail"?',
    answer: 'A trail is a compilation of content generated by your guide, with the assistance of AI and The Boggler, recorded on their phone and delivered to your TV. Each entry is addressed to you specifically — your guide says your name, references your situation, and offers guidance tailored to where you are. It\'s not a broadcast; it\'s a video letter meant only for you.'
  },
  {
    question: 'Why TV?',
    answer: 'There\'s something different about receiving guidance on the big screen. It\'s not scrolling through messages on your phone between distractions. It\'s settling into your couch, picking up the remote, and creating space to receive. The TV experience encourages presence and intention — you\'re choosing to sit down and listen.'
  },
  {
    question: 'How do guides record trail entries?',
    answer: 'Guides use the Boggler Trails phone app. They select a subscriber, create a compilation video, (usually 2-10 minutes), and send it to you. The entry appears on the subscriber\'s TV via The Boggler TV App, addressed to them personally. Guide tails are a mix of spoken word from written content, screen shares, video messages, and other media that the guide posts across different channels that the guide deems tailored to you. A guide can only post a trail to one subscriber at a time. No broadcasts. Everything is curated and personalized.'
  },
  {
    question: 'How do guides make money?',
    answer: 'Guides set their own monthly subscription price. Subscribers pay for access to the guide\'s trail — the ongoing stream of personalized video entries. Guides keep the majority of subscription revenue. It\'s sustainable income from real relationships, not ad impressions.'
  },
  {
    question: 'Can I watch trails on my phone too?',
    answer: 'The primary experience is the TV app — that\'s where the magic happens. We may add phone viewing for convenience, but we believe the lean-back, big-screen experience is what makes trails special. This isn\'t content to scroll past; it\'s guidance to receive with intention.'
  },
  {
    question: 'How often do guides send trail entries?',
    answer: 'That depends on the guide and your relationship. Some send weekly reflections. Others check in after calls. Some send entries when something comes up that reminds them of you. There\'s no formula — it\'s organic, like real correspondence between people who know each other.'
  },
  {
    question: 'Is this meant to replace calls with my guide?',
    answer: 'No — trails complement calls. Think of calls as the synchronous, live connection. Trails fill the space between, keeping the relationship alive and giving guides a way to share thoughts when they arise, not just during scheduled sessions.'
  },
  {
    question: 'When does Boggler Trails launch?',
    answer: 'Boggler Trails is coming soon. Join the waitlist to be notified when we launch. Early subscribers and guides will help shape how trails work.'
  }
];

export default function FAQ({ faqs = defaultFaqs }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-6 bg-light-warm relative z-10">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl md:text-5xl text-dark-teal text-center mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-xl text-secondary-text text-center mb-16 font-lato">
          Everything you need to know about Boggler Trails.
        </p>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-boggler shadow-card overflow-hidden transition-all duration-300 hover:shadow-boggler"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <h3 className="text-lg font-montserrat font-semibold text-heading-dark pr-4">{faq.question}</h3>
                <svg
                  className={`w-6 h-6 text-boggler-teal flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}>
                <div className="px-6 pb-6 text-primary-text font-lato leading-relaxed">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
